var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-right-table-2"},[_c('dv-border-box-6',[_c('div',{staticClass:"table-name"},[_c('img',{attrs:{"src":require("./img/icon2.png")}}),_vm._v("故障设备排行榜 ")]),_c('dv-scroll-board',{attrs:{"config":_vm.config}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }